import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Add Vaults API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_ADD_VAULTS_API_ENDPOINTS = {
  getQuoteTokens: {
    generated: 'apiControllerGetQuoteTokens',
    method: 'get',
    path: '/web/quote_tokens/:blockchainId',
  },
  formatTokenAddress: {
    generated: 'apiControllerFormatTokenAddress',
    method: 'get',
    path: '/web/token/formataddress/:blockchainId/:address',
  },
  getTokenDetails: {
    generated: 'apiControllerGetTokenDetails',
    method: 'get',
    path: '/web/token/info/:blockchainId/:address',
  },
  getPool: {
    generated: 'apiControllerGetPool',
    method: 'get',
    path: '/web/getpool/:exchangeId',
  },
  generateAddress: {
    generated: 'apiControllerGenerateAddress',
    method: 'get',
    path: '/web/generate/:blockchainId',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexAddVaultsEndpointName = keyof typeof DEX_ADD_VAULTS_API_ENDPOINTS;
